import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import { DataTable, LocationFlag, Icon } from "MODULES/shared/components";
import { USER_ROLES } from "MODULES/users/constants";
import { dollars } from "LIB/formatters/currency";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import ExchangeCommissionsIcon from "MODULES/users/components/shared/ExchangeCommissionIcon";
import Status from "./Status";
import { subroleLabel } from "../../helpers";

function renderRow(r, pushHistory) {
  const classes = classNames("clickable", { deactivated: !r.active });
  const handleMailto = e => {
    e.stopPropagation();
  };

  return (
    <tr
      key={r.id}
      className={classes}
      onClick={() => pushHistory(`/users/${r.uuid}`)}
    >
      <td>{r.first_name}</td>
      <td>{r.last_name}</td>
      <td>
        <a href={`mailto:${r.email}`} onClick={handleMailto}>
          {r.email}
        </a>
      </td>
      <MultiLocationFeature>
        <td>
          <LocationFlag location={r.location_id} />{" "}
        </td>
      </MultiLocationFeature>
      <td>
        {USER_ROLES[r.role] && USER_ROLES[r.role].label}
        {r.exchange_commissions && <ExchangeCommissionsIcon />}
      </td>
      <td>{subroleLabel(r.role, r.subrole)}</td>
      <td>{r.buying_limit > 0 && dollars(r.buying_limit)}</td>
      <td className="text-center">
        {r.po_approval_role === "super_approver" && (
          <Icon name="check text-success" />
        )}
      </td>
      <td>
        <Status active={r.active} />
      </td>
    </tr>
  );
}

export function Table({ results, pushHistory, isLoading, pageActions }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Email</th>
        <MultiLocationFeature>
          <th>Location</th>
        </MultiLocationFeature>
        <th>Role</th>
        <th>Subrole</th>
        <th>Buyer Credit Limit</th>
        <th className="text-center">Super approver</th>
        <th>Status</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      first_name: PropTypes.string.isRequired
    })
  ).isRequired,
  pushHistory: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pageActions: PropTypes.shape({}).isRequired
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/users/components/Search/Table.jsx